import React from 'react';

import { SubmitSkeleton } from 'app/component/skeleton/submit/SubmitSkeleton';
import { RepeatComponent } from 'app/component/repeat-component/RepeatComponent';
import { FieldSkeleton } from 'app/component/skeleton/field/FieldSkeleton';
import { RowSkeleton } from 'app/component/skeleton/row/RowSkeleton';
import { RowListSkeleton } from 'app/component/skeleton/row/RowListSkeleton';
import { StepSkeleton } from 'app/component/skeleton/step/StepSkeleton';
import { useWindowType, WindowTypeName } from 'app/utils/useWindowType';

export const ProductParametersSkeleton = () => {
    const [windowType] = useWindowType();

    return (
        <>
            <StepSkeleton windowType={windowType} />
            <div style={{ marginTop: 32 }}>
                <RowListSkeleton
                    rowCount={1}
                    windowType={WindowTypeName.MOBILE}
                />
                <div style={{ marginTop: 24 }}>
                    <RowListSkeleton
                        rowCount={1}
                        windowType={WindowTypeName.MOBILE}
                    />
                </div>
                <div style={{ marginTop: 16 }}>
                    <RowSkeleton
                        windowType={WindowTypeName.MOBILE}
                        isHideTitle
                    />
                </div>
            </div>
            <RepeatComponent numberRepetitions={2}>
                <div style={{ marginTop: 48 }}>
                    <FieldSkeleton windowType={windowType} />
                </div>
            </RepeatComponent>
            <div style={{ marginTop: 48 }}>
                <SubmitSkeleton windowType={windowType} />
            </div>
        </>
    );
};
